import { ColoursObj, TEventrIcons } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { useFormatValue } from "../../hooks/useFormatValue";
import { CardText } from "../subComponents/cardText";
import { ColouredIcon } from "../subComponents/colouredIcon";
interface IActivityDateProps {
  date?: string;
  name?: string;
  icon?: TEventrIcons;
  iconColour?: string;
  visibility?: string;
}
export const ActivityDate = ({ date, name, icon, iconColour, visibility }: IActivityDateProps) => {
  const { formatValue } = useFormatValue();
  return (
    <Stack direction="row" sx={{
      justifyContent: "space-between"
    }}>
      <Stack direction="row" sx={{
        gap: "8px"
      }}>
        <ColouredIcon name={icon ?? "Activity"} iconColour={iconColour ?? ColoursObj.core.secondary} />
        <CardText variant="bodyBold">{name}</CardText>
      </Stack>

      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "8px"
        }}>
        {visibility?.toLowerCase() === "private" ? (
          <ColouredIcon height="16px" name="Private" />
        ) : (
          visibility?.toLowerCase() === "public" && <ColouredIcon height="16px" name="Public" />
        )}
        <CardText variant="bodyBold">{formatValue(date ?? "", "date")}</CardText>
      </Stack>
    </Stack>
  );
};
